<template>
    <div>
        <div class="center" v-if="$store.state.deals.loading_deal">
            <dot-loader class="loader"></dot-loader>
            <div style="margin-top:2rem">Detail Seite wird geladen ...</div>
        </div>
        <div v-else>
            <Alert v-if="finalStatus" :type="finalStatus.alert" style="margin: 1rem 0 2rem 0;">
                <div style="display: flex;">
                    <div style="font-weight: bold; margin-bottom: .5rem;">
                        {{ finalStatus.title }}
                    </div>
                    <div style="padding-left: 5px">
                        {{ '– ' + finalStatus.description }}
                    </div>
                </div>
            </Alert>
            <div class="row-wrapper">
                <!--  D E A L   D E T A I L S  -->
                <div style="flex-grow: 1; max-width:40%; display: flex; flex-flow: wrap;background: white;
                padding: 15px;border-radius: 4px;">
                    <div v-for="info in details" class="detail-info-wrapper" :key="info.name">
                        <div class="label">{{ info.display_name }}</div>
                        <div>{{getInfo(info)}}
                        </div>
                    </div>
                </div>
                <!--  C H A R T S  -->
                <div style="width:60%;padding-left:1.5rem;">
                    <div style="background:white;  border-top-left-radius: 4px;    border-top-right-radius: 4px;">
                        <div class="filter-row">
                            <div class="flex">
                                <div style="font-weight: bold">Zeitraum:</div>
                                <DateSelectionCombo @dateChange="dateChanged" id="deal_details"
                                                    :global="false"
                                                    :disabled="true"
                                                    :addRadioOptions="true"
                                                    :initial-range="selectedDates">
                                </DateSelectionCombo>
                            </div>
                            <!--<AdaButton title="Filter übernehmen" icon="filter" :unicon="true"
                                       @click="fetch"></AdaButton>-->
                        </div>
                    </div>
                    <div class="chart">
                        <div class="chart-filter-container">
                            <div v-for="filter in chartFilter" :key="filter.name"
                                 class="chart-filter"
                                 :class="{active: currentChartFilter.name === filter.name}"
                                 @click="changeChartFilter(filter)">
                                <unicon :name="filter.icon" fill="#607D8B" class="icon"></unicon>
                                {{ filter.display_name }}
                            </div>
                        </div>
                        <LineChart class="chart-wrapper" :width="60"
                                   :unit="currentChartFilter.name === 'brutto_revenue' ? '€' : ''"
                                   :key="currentChartFilter.name"
                                   :digits="2" :height="25"
                                   :title="currentChartFilter.display_name"
                                   :labels="dates"
                                   :data="dealData" type="big"></LineChart>
                        <HorizontalBarChart :labels="['']" :data="advertiserChartData" width="100%"
                                            height="20" :multipleDatasets="true"
                                            :currentChartFilter="currentChartFilter"
                                            title="Advertiser" :unit="currentChartFilter.unit"></HorizontalBarChart>
                    </div>
                </div>
            </div>
            <!-- D A T A T A B L E -->
            <div class="table-container">
                <AdaTableClient :columns="columns"
                                :rows="$store.state.deals.dealData ? $store.state.deals.dealData.groupByDate : []"
                                :transformers="transformers"
                >
                </AdaTableClient>
            </div>
        </div>
    </div>
</template>

<script>
import LineChart from "@/components/charts/LineChart";
import DateSelectionCombo from "@/components/datePicker/DateSelectionCombo";
import Alert from "@/components/Alert";
import moment from "moment";
import AdaTableClient from "@/components/dataTable/AdaTableClient";
import HorizontalBarChart from "@/components/charts/HorizontalBarChart";

function handleData(value, type = null) { //type === number, currency, percentage
    let res = value;
    if (typeof value === "undefined" || value === null) {
        res = '<div class="noData">Keine Daten</div>';
    } else {
        if (type === 'number') {
            res = value.toLocaleString('de-DE');
        } else if (type === 'currency') {
            res = value.toLocaleString('de-DE', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2
            })
        } else if (type === 'percentage') {
            res = value.toLocaleString('de-DE', {
                maximumFractionDigits: 2
            });
            res += ' %';
        }
    }
    return res;
}

function handleDate(value, alternativeResultOnNull = null) {
    let res = '';
    if (typeof value !== "undefined" && value) {
        res = moment(value, moment.ISO_8601).format('DD.MM.YYYY');
    } else if (value === null && alternativeResultOnNull) {
        res = alternativeResultOnNull;
    }
    return res;
}

export default {
    name: "DealDetails",
    components: {HorizontalBarChart, AdaTableClient, Alert, DateSelectionCombo, LineChart},
    data: () => ({
        statusColor: '#4CAF50',
        tableGroupBy: 'date',
        details: [
            {name: 'deal_name', display_name: 'Deal Name'}, //MATCHING -> DEALLISTE -> SSP
            {name: 'deal_id', display_name: 'Deal ID'},
            {name: 'cust_Name', display_name: 'Advertiser', deallist: 'advertiser'},
            {name: 'deal_type', display_name: 'Deal Type'},
            {name: 'placement', display_name: 'Placement'},
            {name: 'device', display_name: 'Device'},
            {name: 'seat', display_name: 'Seat'},
            {name: 'seat_id', display_name: 'Seat ID'},
            {name: 'dsp', display_name: 'DSP'},
            {name: 'format', display_name: 'Format'},
            {name: 'cpm', display_name: 'CPM'},
            {name: 'ssp', display_name: 'SSP'},
            {name: 'budget', display_name: 'Budget'},
            {name: 'targeting', display_name: 'Targeting'},
            {name: 'start', display_name: 'Start'},
            {name: 'end', display_name: 'Ende'},
            {name: 'cus_name', display_name: 'Agentur', deallist: 'agency'},
            {name: 'AgenturDach', display_name: 'Agenturgruppe', deallist: 'agency_group'},
            {name: 'contact', display_name: 'Ansprechpartner'},
            {name: 'trafficker', display_name: 'Trafficker'},
        ],
        chartFilter: [
            {name: 'impressions_won', display_name: 'Ad Impressions', icon: 'mouse', unit: 'AIs'},
            {name: 'brutto_revenue', display_name: 'Umsatz', icon: 'euro', unit: '€'},
            {name: 'bid_rate', display_name: 'Bid Rate', icon: 'bolt'},
            {name: 'win_rate', display_name: 'Win Rate', icon: 'arrow-growth'},
        ],
        currentChartFilter: {name: 'impressions_won', display_name: 'Ad Impressions', icon: 'mouse', unit: 'AIs'},
        selectedDates: null,
        columns: [
            {label: 'Status', name: 'status', width: '1%'},
            {label: 'Datum', name: 'date', type: 'date'},
            {label: 'Requests', name: 'bid_requests'},
            {label: 'Bids', name: 'bids'},
            {label: 'Bid Rate', name: 'bid_rate'},
            {label: 'Win Rate', name: 'win_rate', type: 'number'},
            {label: 'AIs', name: 'impressions_won'},
            {label: 'Umsatz', name: 'brutto_revenue'},
            {label: 'eCPM', name: 'e_cpm'}
        ],
        transformers: [
            {propName: 'date', transform: (value) => handleDate(value)},
            {propName: 'start', transform: (value) => handleDate(value)},
            {propName: 'end', transform: (value) => handleDate(value, 'always on')},
            {propName: 'bid_requests', transform: (value) => handleData(value, "number")},
            {propName: 'bids', transform: (value) => handleData(value, "number")},
            {propName: 'bid_rate', transform: (value) => handleData(value, "percentage")},
            {propName: 'win_rate', transform: (value) => handleData(value, "percentage")},
            {propName: 'impressions_won', transform: (value) => handleData(value, "number")},
            {propName: 'brutto_revenue', transform: (value) => handleData(value, "currency")},
            {propName: 'e_cpm', transform: (value) => handleData(value, "currency")},
            {propName: 'cpm', transform: (value) => handleData(value, "currency")},
            {propName: 'budget', transform: (value) => handleData(value, "currency")},
        ],
    }),
    mounted() {
        if (this.$route.query.start && this.$route.query.end) {
            this.dateChanged({
                start: this.$route.query.start,
                end: this.$route.query.end
            });
        } else {
            this.dateChanged({
                start: moment().subtract(14, 'd').format('YYYY-MM-DD'),
                end: moment().subtract(1, 'd').format('YYYY-MM-DD')
            });
        }
        this.fetch();
    }
    ,
    computed: {
        dates() {
            return this.$store.state.deals.dealData ? this.$store.state.deals.dealData.groupByDate.map((x) => {
                let date = x.date.split(' ')[0].split('-'); //yyyy-mm-dd hh:mm:ss to yyyy-mm-dd
                return date[2] + '.' + date[1] + '.' + date[0];
            }) : [];
        }
        ,
        dealData() {
            return this.$store.state.deals.dealData ? this.$store.state.deals.dealData.groupByDate.map(x => x[this.currentChartFilter.name]) : [];
        },
        advertiserChartData() {
            if (this.$store.state.deals.dealData) {
                let ret = [];
                for (let i = 0; i < this.$store.state.deals.dealData.groupByAdvertiser.length; i++) {
                    ret.push({
                        label: this.$store.state.deals.dealData.groupByAdvertiser[i].cust_Name,
                        data: [this.$store.state.deals.dealData.groupByAdvertiser[i][this.currentChartFilter.name]],
                        rawData: this.$store.state.deals.dealData.groupByAdvertiser[i]
                    })
                }
                return ret;
            } else {
                return [];
            }
        },
        finalStatus() {
            if (this.$store.state.deals.dealData && this.$store.state.deals.dealData.deal) {
                let latest_status = this.$store.state.deals.dealData.deal.latest_status;
                return this.$store.state.deals.statusConfig.find(x => x.name === latest_status);
            }
            return false;
        },
    }
    ,
    methods: {
        fetch() {
            if (this.$route.params.id) {
                this.$store.dispatch('deals/fetchDeal', {id: this.$route.params.id, dates: this.selectedDates})
            }
        }
        ,
        dateChanged(data = null) {
            if (data) this.selectedDates = data;
            if (this.selectedDates.start !== this.$route.query.start || this.selectedDates.end !== this.$route.query.end) {
                this.$router.push({
                    name: 'dealDetails',
                    params: {id: this.$route.params.id},
                    query: {start: this.selectedDates.start, end: this.selectedDates.end}
                })
                this.fetch();
            }
        }
        ,
        changeChartFilter(filter) { // filter = 'impressions_won', 'brutto_revenue', 'bid_rate', 'win_rate'
            this.currentChartFilter = filter;
        }
        ,
        returnNoData(value) {
            let res = value;
            if (typeof value === "undefined" || value === null) {
                res = 'Keine Daten';
            }
            return res;
        },
        updateSelectedGroup(groupByName) {
            this.tableGroupBy = groupByName;
        },
        getInfo(detail) {
            if (this.$store.state.deals.dealData && this.$store.state.deals.dealData.deal &&
                this.$store.state.deals.dealData.deal.length !== 0) {
                if (detail.deallist) {
                    return this.$store.state.deals.dealData.deal[detail.deallist];
                } else if (this.transformers.find(x => x.propName === detail.name)) {
                    return this.transformers.find(x => x.propName === detail.name).transform(this.$store.state.deals.dealData.deal[detail.name]);
                } else {
                    return this.$store.state.deals.dealData.deal[detail.name] &&
                    this.$store.state.deals.dealData.deal[detail.name] !== '-' ?
                        this.$store.state.deals.dealData.deal[detail.name] : '<div class="noData">Keine Daten</div>'
                }
            } else {
                return '<div class="noData">Keine Daten</div>';
            }
        }
    }
    ,
}
</script>

<style lang="scss" scoped>
.chart {
    padding-bottom: 10px;
    display: inline-block;
    width: 100%;
    height: calc(100% - 56px);
    text-align: center;
    background-color: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;

    .chart-filter-container {
        display: flex;
        justify-content: center;
        color: #607D8B;

        .chart-filter {
            transition: all 0.2s ease-in-out;
            cursor: pointer;
            display: flex;
            align-items: center;
            border: thin solid currentColor;
            padding: 5px;
            border-radius: 4px;
            margin: 1rem 1rem .5rem 1rem;
            opacity: 0.3;

            .unicon {
                margin-right: 5px;
            }
        }

        .active {
            opacity: 1;
        }
    }
}


.chart-header {
    font-weight: bold;
    padding: 1rem;
    height: 1.5rem;
    position: absolute;
}

.chart-header-text {
    float: left;
    font-size: 1em;
    margin-bottom: 1rem;
}

.table-container {
    background: white;
    padding: 1rem 1rem 2rem;
    border-radius: 4px;
    margin-top: 1.5rem;
}

.filter-row {
    background: white;
    padding: 15px 10px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    justify-content: space-between;
    border-bottom: 1px solid #ECEFF1;
    margin: 0 1rem;
}

.row-wrapper {
    display: flex;
    flex-flow: wrap;
}

.detail-info-wrapper {
    min-width: 50%;
    padding: 0.3rem 3% 5px 0.3rem;
    border-bottom: 1px solid #ECEFF1;
    margin-bottom: 0.5rem;
    word-break: break-word;
}

.label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    width: fit-content;
    padding: 3px 6px;
    font-size: 0.8em;
    margin: 0 5px 5px 0;
    cursor: default;
    position: relative;
    background: #752b77;
    color: white;
}

:deep( .noData) {
    color: #B0BEC5;
    user-select: none;
}

.center {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    height: 70vh;
}

</style>